import { AccountBase, AccountBaseOptions } from './account-base';
import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-shop-account', observe: true })
export class ShopAccountComponent extends AccountBase {
	protected options: AccountBaseOptions = {
		selectors: {
			submitButton: ''
		},
		disabled: '--disabled'
	};

	protected handleSubmit() {
		return false;
	}
}
